import { Component } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from "@angular/material/legacy-snack-bar";
import { Router } from '@angular/router';
import { Helpers } from 'src/helpers/helpers';
import { CareplusAgencyDashboard } from 'src/models/careplus-agency-dashboard';
import { AccountService } from 'src/services/account.service';
import { CareplusAgencyService } from 'src/services/careplus-agency-service';
import { MatLegacyCardModule } from "@angular/material/legacy-card";

@Component({
  selector: 'app-careplus-agency-dashboard',
  templateUrl: './careplus-agency-dashboard.component.html',
  styleUrls: ['./careplus-agency-dashboard.component.css'],
  
})
export class CareplusAgencyDashboardComponent {
pageTitle = "Dashboard";
  dashboardCounts: CareplusAgencyDashboard;

  constructor(
    private _agencyService: CareplusAgencyService,
    private helper: Helpers,
    private accountService: AccountService,
    private router: Router,
    private snackBar: MatSnackBar,
  ) {}

  ngOnInit(): void {
    this._agencyService.getCareplusDashboardCounts().subscribe((data) => {
      this.dashboardCounts = data;
    });
    this.accountService.getAccount().subscribe((data) => {
      if (!data.activated) {
        this.helper.logout();
        this.router.navigate(["/"]);
        this.snackBar.open(
          "Your account is not active, please contact admin.",
          "Close",
          {
            duration: 3000,
          },
        );
      }
    });
  }
}
